// Neuber Program Variables
export const neuberVariables: any = {
    programTitle: "Neuberger Berman",
    effectiveDates: "2/01/2023 - 2/01/2024",
    faqUrl: "https://alliantprivateclient.com/media/10wnwkrl/groupexcessliability-faq.pdf",
    learnMoreUrl: "https://alliantprivateclient.com/media/pjcnfgpo/complimentary-personal-insurance-review-alliant-private-client.pdf",
    supportEmail: "Jeffrey.Elliott@alliant.com;Ayisha.Knight@alliant.com",
    feeDisclaimer: "",
    EL_Items: [
        "Neuber_EL_Header",
        ["Neuber_EL_2M", "$2,000,000", "$1,061"],
        ["Neuber_EL_3M", "$3,000,000", "$1,150"],
        ["Neuber_EL_5M", "$5,000,000", "$1,381"],
        ["Neuber_EL_10M", "$10,000,000*", "$2,024"],
        ["Neuber_EL_15M", "$15,000,000**", "$4,050"],
        ["Neuber_EL_20M", "$20,000,000**", "$5,981"],
        ["Neuber_EL_25M", "$25,000,000**", "$7,849"],
        ["Neuber_EL_30M", "$30,000,000**", "$9,750"],
        ["Neuber_EL_40M", "$40,000,000**", "$14,405"],
        ["Neuber_EL_50M", "$50,000,000**", "$19,581"]
    ],
    EL_Included: "$2,000,000",
    EL_Disclaimers: ["*The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.", "**It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire. These limits are subject to prior underwriting approval. These requirements have been waived for current participants renewing at their expiring limit."],
    UM_Items: [
        "Neuber_UM_Header",
        ["Neuber_UM_2M", "$2,000,000", "included above"],
        ["Neuber_UM_3M", "$3,000,000", "$205"],
        ["Neuber_UM_5M", "$5,000,000", "$523"]
    ],
    UM_Disclaimers: ["*Please note that the UM/UIM limit cannot be higher than the liability limit."],
    EPLI_Items: [
        "Neuber_EP_Header",
        ["Neuber_EP_250K", "$250,000 per occurrence / $500,000 aggregate", "$10,000", "included above"],
    ],
    EPLI_Disclaimer: "",
    CI_Items: [
        "Neuber_PR_Parent",
        "Neuber_PR_Yes",
        "Neuber_PR_No"
    ],
};

